
import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { CardBody, Card, CardHeader, Col, Row } from 'reactstrap'
import { withRouter } from 'react-router'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { FaEdit } from 'react-icons/fa'

class PendingAppellant extends Component {
  render () {
    const appellant = this.props.admin.appeals.filter(appeal => (appeal.status === 'registered' || appeal.status === 'writing' || appeal.status === 'pending appellant response'))

    return (
      <div>
        <Card>
          <CardHeader>
            <h4>Pending Appellant</h4>
          </CardHeader>
          <CardBody>
            <div className='actions'>
              {
                appellant.map((appeal, i) => {
                  return (<Row key={i}><Col lg='8'><p><span className='registration-ui'>{appeal.reg}</span></p><p><b>PCN: </b>{appeal.pcn}<br /><b>Status: </b>{appeal.status}</p></Col><Col lg='2'><Link className='btn-primary btn btn-sm' to={`/admin/appeal/${appeal.appealID}`}><FaEdit /> View</Link></Col></Row>)
                })}
            </div>
          </CardBody>
        </Card>
      </div>
    )
  }
}

PendingAppellant.propTypes = {
  admin: PropTypes.object
}

const mapStateToProps = ({ admin }) => ({
  admin
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
    },
    dispatch)

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(PendingAppellant))



// WEBPACK FOOTER //
// ./src/containers/admin/AdminDashBoard/_PendingAppellant.jsx